<template>
  <div class="mod-distcommission">
    <el-form
      :inline="true"
      :model="searchForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item>
        <el-input
          v-model="searchForm.nickname"
          placeholder="用户昵称"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.buyerNickname"
          placeholder="买家昵称"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.commissionType"
          clearable
          placeholder="提成类型"
        >
          <el-option key="1" label="一级分销" value="1" />
          <el-option key="2" label="二级分销" value="2" />
          <el-option key="3" label="一级推广" value="3" />
          <el-option key="4" label="二级推广" value="4" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.isReceive"
          clearable
          placeholder="是否到账"
        >
          <el-option key="1" label="未到账" value="0" />
          <el-option key="2" label="已到账" value="1" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button @click="getDataList()"> 查询 </el-button>
        <!--        <el-button v-if="isAuth('mall:distcommission:delete')" type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>-->
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      style="width: 100%"
      @selection-change="selectionChangeHandle"
    >
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50"
      />
      <!--      <el-table-column-->
      <!--        prop="userId"-->
      <!--        header-align="center"-->
      <!--        align="center"-->
      <!--        label="用户ID">-->
      <!--      </el-table-column>-->
      <el-table-column
        prop="nickname"
        header-align="center"
        align="center"
        label="用户昵称"
      />
      <el-table-column
        prop="buyerNickname"
        header-align="center"
        align="center"
        label="买家昵称"
      />
      <!--      <el-table-column-->
      <!--        prop="orderId"-->
      <!--        header-align="center"-->
      <!--        align="center"-->
      <!--        label="订单ID">-->
      <!--      </el-table-column>-->
      <el-table-column
        prop="commissionType"
        header-align="center"
        align="center"
        label="提成类型"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.commissionType === 1"
            size="small"
            type="success"
          >
            一级分销
          </el-tag>
          <el-tag
            v-else-if="scope.row.commissionType === 2"
            size="small"
            type="success"
          >
            二级分销
          </el-tag>
          <el-tag
            v-else-if="scope.row.commissionType === 3"
            size="small"
            type="info"
          >
            一级推广
          </el-tag>
          <el-tag
            v-else-if="scope.row.commissionType === 4"
            size="small"
            type="info"
          >
            二级推广
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderId"
        header-align="center"
        align="center"
        label="订单编号"
      />
      <el-table-column
        prop="income"
        header-align="center"
        align="center"
        label="结算收益"
      />
      <el-table-column
        prop="incomeTime"
        header-align="center"
        align="center"
        label="结算时间"
      />
      <!--      <el-table-column-->
      <!--        prop="goodsId"-->
      <!--        header-align="center"-->
      <!--        align="center"-->
      <!--        label="商品ID">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="skuId"-->
      <!--        header-align="center"-->
      <!--        align="center"-->
      <!--        label="SKU_ID">-->
      <!--      </el-table-column>-->
      <el-table-column
        prop="commission"
        header-align="center"
        align="center"
        label="提成比例"
      />
      <el-table-column
        prop="isReceive"
        header-align="center"
        align="center"
        label="是否到账"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isReceive === 0" size="small" type="warning">
            未到账
          </el-tag>
          <el-tag
            v-else-if="scope.row.isReceive === 1"
            size="small"
            type="success"
          >
            已到账
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="isAuth('mall:distcommission:info')"
            type="text"
            size="small"
            @click="showDetails(scope.row.id)"
          >
            查看
          </el-button>
          <!--          <el-button v-if="isAuth('mall:distcommission:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>-->
          <!--          <el-button v-if="isAuth('mall:distcommission:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    />
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    />
  </div>
</template>

<script>
import AddOrUpdate from './distcommission-add-or-update';

export default {
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      searchForm: {
        nickname: '',
        buyerNickname: '',
        commissionType: '',
        isReceive: '',
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  activated() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.$http({
        url: '/mall/distcommission/list',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          nickname: this.searchForm.nickname,
          buyerNickname: this.searchForm.buyerNickname,
          commissionType: this.searchForm.commissionType,
          income: this.searchForm.income,
          commission: this.searchForm.commission,
          isReceive: this.searchForm.isReceive,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 查看详情
    showDetails(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, true);
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      let ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(`确定对[id=${ids.join(',')}]进行[删除]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http({
            url: '/mall/distcommission/delete',
            method: 'post',
            data: ids,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.getDataList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
